import Safety from "../../../../football/rules/defensive/safety/safety";

export default class FlagSafety extends Safety {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        await super.apply(gameContext, ruleContext, eventConfiguration, {
            play,
            fragment
        });
        gameContext.switchPossession();
        return [];
    }
}
